import dynamic from "@redux-dynostore/react-redux";
import subspaced from "@redux-dynostore/react-redux-subspace";
import { attachReducer } from "@redux-dynostore/redux-subspace";
import React, { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import styled from "styled-components";
import { ToastType } from "../../../../ToastManager/constants";
import { sendNotification } from "../../../../ToastManager/ToastManager";
import {
  mapDispatchToProps,
  mapStateToProps,
  totalParticipantsReducer,
} from "./TotalParticpants.store";

const StyledTotalParticipants = styled.div`
  border-radius: 5px;
  background-color: #a0248d;
  color: white;
  padding: 4rem;
  width: 50%;
  transition: width 0.5s;
  @media (max-width: 1400px) {
    width: 100%;
  }
  & > h1 {
    margin-top: 20px;
  }
`;

export const TotalParticipants = ({
  total,
  fetchTotalParticipants,
  resetState,
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (!total) {
      fetchTotalParticipants().catch((e) =>
        sendNotification(e, ToastType.ERROR)
      );
    }
  }, [fetchTotalParticipants, total]);

  useEffect(() => {
    return () => resetState();
  }, [resetState]);

  const totalParticipants = useMemo(
    () => (total !== null ? total : t("appText.totalParticipants.loading")),
    [total]
  );

  return (
    <StyledTotalParticipants>
      <h4>{t("appText.totalParticipants.registered")}</h4>
      <h1>{totalParticipants}</h1>
    </StyledTotalParticipants>
  );
};

export default dynamic(
  "dashboardReducer",
  subspaced({
    // We map extra state because we might need to acess other stores for data, subspace is self contained.
    mapExtraState: (state) => ({ loginReducer: state.loginReducer }),
  }),
  attachReducer(totalParticipantsReducer)
)(connect(mapStateToProps, mapDispatchToProps)(TotalParticipants));
